import React from 'react';

import Header from '../../layout/Header.jsx';
import ListLocations from '../../lists/ListLocations.jsx';

const PageLocationsList = () => (
  <div>
    <Header>Race Locations</Header>
    <ListLocations />
  </div>
);

export default PageLocationsList;
